import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield } from '@mui/icons-material';
export function GuaranteeSection() {
  return <section className="py-14 px-4 bg-miel-crimson relative overflow-hidden" data-id="element-115">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" data-id="element-116" />
      <div className="absolute inset-0 bg-gradient-to-b from-miel-darker/50 to-transparent" data-id="element-117" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-118">
        <FadeIn data-id="element-119">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-miel-darker border-4 border-miel-gold mb-8 shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-120">
            <Shield className="text-miel-gold" style={{
            fontSize: 40
          }} data-id="element-121" />
          </div>

          <h2 className="font-playfair text-3xl md:text-5xl text-miel-cream font-bold mb-6" data-id="element-122">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-miel-cream/90 mb-8 font-medium" data-id="element-123">
            <p data-id="element-124">Abrís los tomos. Hacés los rituales. Seguís el protocolo.</p>
            <p data-id="element-125">Si en 7 días no es lo que esperabas:</p>
            <p className="text-2xl md:text-3xl font-playfair text-miel-gold italic py-2" data-id="element-126">
              devolución del 100%
            </p>
            <p data-id="element-127">sin formularios, sin drama, sin explicaciones.</p>
          </div>

          <div className="inline-block bg-miel-darker/40 backdrop-blur-sm border border-miel-cream/20 rounded-full px-6 py-2 text-sm text-miel-cream/80" data-id="element-128">
            Tasa de devoluciones: menos del 1%.
          </div>
        </FadeIn>
      </div>
    </section>;
}